var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flow-view',{attrs:{"xmlData":_vm.xmlData,"taskList":_vm.taskData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }